// added .txt so that webpack file-loader is used instead
// @ts-ignore
import countries50mUrl from './countries-50m.topo.json.txt';

export const getCountries50m = (): Promise<any> =>
  fetch(countries50mUrl).then(response => response.json());
